import { render, staticRenderFns } from "./Highest.vue?vue&type=template&id=b2fa3dd4"
var script = {}


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b2fa3dd4')) {
      api.createRecord('b2fa3dd4', component.options)
    } else {
      api.reload('b2fa3dd4', component.options)
    }
    module.hot.accept("./Highest.vue?vue&type=template&id=b2fa3dd4", function () {
      api.rerender('b2fa3dd4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/PriorityIcons/Highest.vue"
export default component.exports